import { z } from "zod";

const ErrorsResponseSchema = z.object({
    name: z.array(z.string()),
    group: z.array(z.string()),
});

export const ValidationErrorResponse = z.object({
    code: z.number(),
    message: z.string(),
    errors: ErrorsResponseSchema,
    success: z.boolean(),
});

export type ValidationErrorResponse = z.infer<typeof ValidationErrorResponse>;